<template>
    <div v-if="status == 'NOT_FOUND'" class="button is-large is-fullwidth is-gray is-light">
        <p>{{ fdID }}</p>
        <p>{{ status }}</p>
    </div>
    <div v-else class="button is-large is-fullwidth is-primary is-light" @click="toggleDeliveryUpdateTab"
        :class="[!status || status == 'NOT_DELIVERED' ? 'is-danger' : '']">
        <p>{{ fdID }}</p>
        <p v-if="status">{{ status }}</p>
        <p v-else>NOT_COLLECTED</p>
    </div>

    <div class="modal" :class="[showDeliveryUpdateTab ? 'is-active' : '']">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Beneficiary ID: {{ beneficiaryID }}</p>
                <button class="delete" aria-label="close" @click="toggleDeliveryUpdateTab"></button>
            </header>
            <section class="modal-card-body">
                <table class="table is-fullwidth">
                    <tbody>
                        <tr>
                            <th>
                                Name
                            </th>
                            <td>
                                {{ name }}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Address
                            </th>
                            <td>
                                <p>{{ unit }} </p>
                                <p>{{ block }}, {{ street }}</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Delivery Mode
                            </th>
                            <td>
                                <span v-if="selfCollection">Self Collection</span>
                                <span v-else-if="drivingDelivery">Driving Delivery</span>
                                <span v-else>Walking Delivery</span>
                            </td>
                        </tr>
                        <tr v-if="!selfCollection && deliveryTeam">
                            <th>
                                Delivery Team
                            </th>
                            <td>
                                {{ deliveryTeam }}
                            </td>
                        </tr>
                        <tr v-if="deliverySort && drivingDelivery">
                            <th>
                                Delivery Sort
                            </th>
                            <td>
                                {{ deliverySort }}
                            </td>
                        </tr>
                        <tr v-if="completed">
                            <th>
                                Status
                            </th>
                            <td>
                                {{ status }}
                            </td>
                        </tr>
                        <tr v-if="deliveryNotes">
                            <th>
                                Notes
                            </th>
                            <td>
                                {{ deliveryNotes }}
                            </td>
                        </tr>
                        <tr v-if="completedAtTime">
                            <th>
                                Completed At
                            </th>
                            <td>
                                {{ completedAtTime.toDate() }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </section>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            showDeliveryUpdateTab: false,
            notes: "",
            isNotesRequired: false,
            isLoading: false,
            error: ""
        }
    },
    props: ['name', 'dryBag', 'quantity', 'unit', 'block', 'street', 'completed', 'completedAtTime', 'age', 'deliverySort', 'fdID', 'fdStatus', 'beneficiaryID', 'status', 'selfCollection', 'drivingDelivery', 'deliveryNotes', 'deliveryTeam', 'drivingTeams', 'walkingTeams'],
    methods: {
        toggleDeliveryUpdateTab() {
            this.showDeliveryUpdateTab = this.showDeliveryUpdateTab ? false : true;
        }
    }
}
</script>

<style scoped>
.button {
    font-size: large;
    justify-content: space-between;
}
</style>